export enum Model {
  BUILDING_BLOCK_MODEL = 'building_block_model',
  MENU_MODEL = 'menu_model',
  CONFIGURATION_MODEL = 'configurationModel'
}
